// https://gsap.com/docs/v3/
// https://gsap.com/docs/v3/Installation/?tab=npm&module=esm&method=private+registry&tier=free&club=false&require=false&trial=true&plugins=ScrollTrigger%2C+Observer%2C+Draggable%2C+MotionPathPlugin%2C+EaselPlugin%2C+TextPlugin
import {cl} from "./common";
import gsap from 'gsap/dist/gsap';

import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// Animations Slogan HomeHero
document.addEventListener("DOMContentLoaded", function () {
    // Check if #home-hero exists
    const teaserBlock = document.querySelector("#home-hero");
    if (!teaserBlock) return; // Cancel if #home-hero not exists

    let mm = gsap.matchMedia();

    // Meium Breakpoint setup
    mm.add("(min-width: 768px)", () => {
        const sloganConfigs = [
            { id: "#f-slogan-1", left: "120px" },
            { id: "#f-slogan-2", left: "-180px" },
            { id: "#f-slogan-3", left: "120px" },
            { id: "#f-slogan-4", left: "-180px" }
        ];
        
        const slogans = sloganConfigs.map(config => config.id);
        
        gsap.to(slogans, {
            left: function (index) {
                return sloganConfigs[index].left; // Zielposition
            },
            duration: 1,
            scrollTrigger: {
                trigger: "#home-hero-inner", // Element für den Trigger
                start: "top 0%", 
                end: "bottom 30%",
                scrub: true,
                markers: false,
            }
        });
        
        gsap.to("#home-hero-inner", {
            position: "fixed", // Zielzustand,
            scrollTrigger: {
                trigger: "#page-content", // Das Element, das die Animation auslöst
                start: "top 100%", // Div | Vierwport top-0% bottom-100%
                //end: "bottom 100%", // Div | Vierwport top-0% bottom-100%
                scrub: true, // Die Animation ist scrollbar synchronisiert
                markers: false // Debug-Markierungen anzeigen (optional)
            }
        });
    });

});

// Animations Teaser Block
document.addEventListener("DOMContentLoaded", function () {
    const teaserBlocks = document.querySelectorAll(".teaser-block");

    teaserBlocks.forEach(teaserBlock => {
        const teaserImg1 = teaserBlock.querySelector(".teaser-img-1");
        const teaserImg2 = teaserBlock.querySelector(".teaser-img-2");
        const teaserImg3 = teaserBlock.querySelector(".teaser-img-3");

        if (teaserImg1 && teaserImg2 && teaserImg3) {
            let timeline = gsap.timeline({ paused: true });

            timeline.to(teaserImg1, {
                rotation: "-=10",         
                duration: 0.3,      
                ease: "power2.out",   
            });

            timeline.to(teaserImg2, {
                rotation: "+=10",        
                duration: 0.3,      
                ease: "power2.out",   
            }, "<"); 

            timeline.to(teaserImg3, {
                rotation: "-=10",        
                duration: 0.3,      
                ease: "power2.out",   
            }, "<"); 

            teaserBlock.addEventListener("mouseenter", function () {
                timeline.play(); // Startet die Animation
            });

            teaserBlock.addEventListener("mouseleave", function () {
                timeline.reverse(); // Animation zurückfahren
            });
        }
    });
});

// Animations Teaser Card A
document.addEventListener("DOMContentLoaded", function () {
    const teaserBlocks = document.querySelectorAll(".teaser-card");

    teaserBlocks.forEach(teaserBlock => {
        const teaserImg1 = teaserBlock.querySelector(".teaser-card-img-a1");
        const teaserImg2 = teaserBlock.querySelector(".teaser-card-img-a2");

        if (teaserImg1 && teaserImg2) {
            let timeline = gsap.timeline({ paused: true });

            timeline.to(teaserImg1, {
                top: "-10px",         
                duration: 0.3,      
                ease: "power2.out",   
            });

            timeline.to(teaserImg2, {
                rotation: "+=3",        
                duration: 0.3,      
                ease: "power2.out",   
            }, "<"); 

            teaserBlock.addEventListener("mouseenter", function () {
                timeline.play(); // Startet die Animation
            });

            teaserBlock.addEventListener("mouseleave", function () {
                timeline.reverse(); // Animation zurückfahren
            });
        }
    });
});

// Animations Teaser Card A
document.addEventListener("DOMContentLoaded", function () {
    const teaserBlocks = document.querySelectorAll(".teaser-card");

    teaserBlocks.forEach(teaserBlock => {
        const teaserImg1 = teaserBlock.querySelector(".teaser-card-img-b1");
        const teaserImg2 = teaserBlock.querySelector(".teaser-card-img-b2");

        if (teaserImg1 && teaserImg2) {
            let timeline = gsap.timeline({ paused: true });

            timeline.to(teaserImg1, {
                rotation: "-=3",         
                duration: 0.3,      
                ease: "power2.out",   
            });

            timeline.to(teaserImg2, {
                rotation: "+=3",        
                duration: 0.3,      
                ease: "power2.out",   
            }, "<"); 

            teaserBlock.addEventListener("mouseenter", function () {
                timeline.play(); // Startet die Animation
            });

            teaserBlock.addEventListener("mouseleave", function () {
                timeline.reverse(); // Animation zurückfahren
            });
        }
    });
});

// Animation Sitefooter
document.addEventListener("DOMContentLoaded", function () {
    const teaserBlocks = document.querySelectorAll("#site-footer");

    gsap.to("#site-footer", {
        zIndex: 5, // Zielzustand,
        display:'flex',
        scrollTrigger: {
            trigger: "#page-content", // Das Element, das die Animation auslöst
            start: "top 50%", // Div | Vierwport top-0% bottom-100%
            //end: "bottom 100%", // Div | Vierwport top-0% bottom-100%
            scrub: true, // Die Animation ist scrollbar synchronisiert
            markers: false // Debug-Markierungen anzeigen (optional)
        }
    });
});







